import { TournamentAdmin } from '@/src/domain/models';
import { Text, TouchableOpacity, View } from 'react-native';
import { createStyles } from '../TournamentDetailScreen.styles';

interface AdminItemProps {
  admin: TournamentAdmin;
  canManageAdmins: boolean;
  onRemove: (admin: TournamentAdmin) => void;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    error: string;
  };
}

export const AdminItem = ({ admin, canManageAdmins, onRemove, colors }: AdminItemProps) => {
  const styles = createStyles();

  return (
    <View style={[styles.adminItem, { backgroundColor: colors.card, borderColor: colors.border }]}>
      <View style={styles.adminInfo}>
        <Text style={[styles.adminEmail, { color: colors.text }]}>{admin.userEmail}</Text>
        <Text style={[styles.adminRole, { color: colors.textSecondary }]}>{admin.role}</Text>
      </View>
      {canManageAdmins && (
        <TouchableOpacity
          onPress={() => onRemove(admin)}
          style={[styles.removeAdminButton, { backgroundColor: colors.error }]}
        >
          <Text style={styles.removeAdminButtonText}>✕</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};
